module.exports = __webpack_public_path__ + "img/h5banner_2025.c0b9d5d8.jpg";